import React from 'react';
import './Header.scss';
import Header from './Header';
import { useHeaderModel } from './useHeaderModel';
import HeaderMobile from './HeaderMobile';

export const HeaderWrapper = (props) => {
  const { isLoading, data: headerModel } = useHeaderModel(
    props.currentPageId,
    props.initialHeaderModel
  );
  const resolvedHeaderModel = headerModel ?? props.initialHeaderModel;

  if (!resolvedHeaderModel && isLoading) {
    return null;
  }

  return (
    <div className='bg-neutralYellow'>
      <HeaderMobile 
        headerModel={resolvedHeaderModel} 
        frontPageTitle={props.frontPageTitle}
        frontPageUrl={props.frontPageUrl}
      />
      <Header
        headerModel={resolvedHeaderModel}
        frontPageTitle={props.frontPageTitle}
        frontPageUrl={props.frontPageUrl}
      /> 
    </div>
  )
}

export default HeaderWrapper;